import { useRef, useState, type ReactNode } from 'react';

interface AccordionProps {
  titulo: string;
  /** Resumo mostrado à direita do título (ex.: total). */
  resumo?: ReactNode;
  abertoInicial?: boolean;
  children: ReactNode;
  className?: string;
}

// Seção recolhível: abre/fecha com animação de altura de 200 ms.
export default function Accordion({
  titulo,
  resumo,
  abertoInicial = false,
  children,
  className = '',
}: AccordionProps) {
  const [aberto, setAberto] = useState(abertoInicial);
  const ref = useRef<HTMLDivElement>(null);
  const altura = aberto ? ref.current?.scrollHeight ?? 0 : 0;

  return (
    <div className={`overflow-hidden rounded-[18px] bg-background-50 shadow-pcard ${className}`}>
      <button
        type="button"
        onClick={() => setAberto((v) => !v)}
        aria-expanded={aberto}
        className="aperta flex w-full cursor-pointer items-center justify-between gap-3 px-4 py-3.5 text-left"
      >
        <span className="truncate text-[15px] font-bold text-foreground-950">{titulo}</span>
        <span className="flex shrink-0 items-center gap-2">
          {resumo && <span className="text-[13px] font-semibold text-foreground-600">{resumo}</span>}
          <span
            className={`flex h-5 w-5 items-center justify-center text-foreground-400 transition-transform duration-200 ${
              aberto ? 'rotate-180' : ''
            }`}
          >
            <i className="ri-arrow-down-s-line text-xl" aria-hidden />
          </span>
        </span>
      </button>
      <div
        style={{ height: altura }}
        className="overflow-hidden transition-[height] duration-200 ease-out motion-reduce:transition-none"
      >
        <div ref={ref} className="px-4 pb-4">
          {children}
        </div>
      </div>
    </div>
  );
}